import { Cell, Grid, InfoLabel, Text } from 'bold-ui'
import StatusSquare from 'view/atendimentos/detail/historico/components/StatusSquare'
import { cuidadoCompartilhadoClassificacaoPrioridadeRecord } from 'view/atendimentos/detail/soap/plano/cuidado-compartilhado/model-cuidadocompartilhado'
import { formatCiapCid } from 'view/cuidados-compartilhados/util-cuidadoCompartilhado'

import { HistoricoPlanoPecGuiaEncaminhamento } from './HistoricoPlanoPecGuiaEncaminhamentoList'

interface HistoricoPlanoPecGuiaEncaminhamentoPanelProps {
  guiaEncaminhamento: HistoricoPlanoPecGuiaEncaminhamento
  showOnlyDwFields?: boolean
}

export const HistoricoPlanoPecGuiaEncaminhamentoPanel = ({
  guiaEncaminhamento,
  showOnlyDwFields = false,
}: HistoricoPlanoPecGuiaEncaminhamentoPanelProps) => {
  const { ciap, cid10, cbo, discussao, classificacaoPrioridade, especialidade } = guiaEncaminhamento

  const {
    label: classificacaoRiscoLabel,
    mainColor: classificacaoRiscoColor,
  } = cuidadoCompartilhadoClassificacaoPrioridadeRecord[classificacaoPrioridade]

  if (showOnlyDwFields) {
    return (
      <Grid gap={2}>
        <Cell size={4}>
          <InfoLabel title='CBO'>
            <Text>{cbo?.nome?.capitalize?.()}</Text>
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Problemas/condições'>
            <Text>{formatCiapCid(ciap, cid10)}</Text>
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Classificação de prioridade'>
            <StatusSquare description={classificacaoRiscoLabel} color={classificacaoRiscoColor} />
          </InfoLabel>
        </Cell>
      </Grid>
    )
  }

  return (
    <>
      <Grid gap={2}>
        <Cell size={4}>
          <InfoLabel title='CBO'>
            <Text>{cbo?.nome?.capitalize?.()}</Text>
          </InfoLabel>
        </Cell>
        {especialidade && (
          <Cell size={5}>
            <InfoLabel title='Especialidade'>
              <Text>{especialidade?.nome?.capitalize?.()}</Text>
            </InfoLabel>
          </Cell>
        )}
      </Grid>

      <Grid gap={2}>
        <Cell size={4}>
          <InfoLabel title='Problemas/condições'>
            <Text>{formatCiapCid(ciap, cid10)}</Text>
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Classificação de prioridade'>
            <StatusSquare description={classificacaoRiscoLabel} color={classificacaoRiscoColor} />
          </InfoLabel>
        </Cell>
      </Grid>

      {discussao && (
        <Grid gap={2}>
          <Cell size={8}>
            <InfoLabel title='Discussão'>
              <Text dangerouslySetInnerHTML={{ __html: discussao }} />
            </InfoLabel>
          </Cell>
        </Grid>
      )}
    </>
  )
}
